import { render, staticRenderFns } from "./NoClients.vue?vue&type=template&id=2d21fa94&"
import script from "./NoClients.vue?vue&type=script&lang=js&"
export * from "./NoClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports